import React from 'react';

import {
    Modal,
    Button,
    Box,
    SpaceBetween,
    Alert,
    ColumnLayout,
} from '@amzn/awsui-components-react-v3';

interface EditDeliveryDetailsQualificationsModalProps {
    visible: boolean;
    onCancel: any;
    onConfirm: any;
    instructorConflict: any;
    formValues: any;
    missingQualifications: Array<string> | null;
}

const EditDeliveryDetailsQualificationsModal = ({
    onCancel,
    onConfirm,
    instructorConflict,
    visible,
    formValues,
    missingQualifications,
}: EditDeliveryDetailsQualificationsModalProps) => {
    return (
        <Modal
            onDismiss={() => onCancel}
            visible={visible}
            closeAriaLabel="Close modal"
            size="medium"
            data-testid={`ConfirmQualificationsModal`}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button
                            variant="link"
                            onClick={() => onCancel()}
                            data-testid={`ConfirmQualificationsCancel`}
                            key={`ConfirmQualificationsCancel`}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            data-testid={`ConfirmQualificationsConfirm`}
                            key={`ConfirmQualificationsConfirm`}
                            onClick={() => {
                                onConfirm();
                            }}
                        >
                            Yes, continue
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={`Instructor conflict`}
        >
            <Alert
                onDismiss={() => {}}
                visible={true}
                dismissAriaLabel="Close alert"
                type="warning"
                key={`missing-qualifications-alert`}
            >
                {`${instructorConflict?.instructor.full_name}`} does not have
                the recommended qualifications for this activity. Continue
                assigning them?
            </Alert>
            <ColumnLayout key={`missing-qualifications-list`}>
                <div
                    data-awsui-column-layout-root="true"
                    className="reassign-adjacent-activity"
                >
                    <span className="reassign-adjacent-activity-title">
                        Missing recommended qualification:
                    </span>
                    {missingQualifications &&
                        missingQualifications.map(
                            (missingQualification, index) => {
                                return (
                                    <span
                                        key={`missing-qualification-${index}`}
                                    >
                                        {missingQualification ===
                                            'wrong_language' && (
                                            <span>
                                                Delivery language:{' '}
                                                {formValues.delivery_language}
                                            </span>
                                        )}
                                        {missingQualification ===
                                            'wrong_country' && (
                                            <span>
                                                Delivery country:{' '}
                                                {formValues.delivery_country}
                                            </span>
                                        )}
                                        {missingQualification ===
                                            'wrong_course' && (
                                            <span>
                                                Approved course:{' '}
                                                {formValues.course_name}
                                            </span>
                                        )}
                                    </span>
                                );
                            },
                        )}
                </div>
            </ColumnLayout>
        </Modal>
    );
};

export default EditDeliveryDetailsQualificationsModal;
